const getters = {
    userInfo: state => state.user.userInfo,
    current: state => state.current.campus
    // tabsList: state => state.menu.tabsList,
    // isCollapse: state => state.menu.isCollapse,
    // currentMenu: state => state.menu.currentMenu,
    // service_account: state => state.mp.service_account,
    // service_account_id: state => state.mp.service_account_id,
    // assignedButton: state => state.assigned.button,
    // assignedRouter: state => state.assigned.router,    
  };

  export default getters;
  